var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { ProductCategory } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
import { useNavigate } from 'react-router';
var ProductCategoryService = /** @class */ (function (_super) {
    __extends(ProductCategoryService, _super);
    function ProductCategoryService() {
        var _this = _super.call(this) || this;
        _this.productCategoryRoot = 'product_categories';
        _this.successMessage = '';
        return _this;
    }
    ProductCategoryService.prototype.useProductCategories = function () {
        var _this = this;
        return useQuery(queries.inventory.productCategories, function () {
            return _this.get(_this.productCategoryRoot);
        }, {
            select: function (response) {
                var data = response.data;
                return plainToInstance(ProductCategory, data);
            }
        });
    };
    ProductCategoryService.prototype.useCreateProductCategory = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        return useMutation(function (_a) {
            var productCategory = _a.productCategory, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { product_category: instanceToPlain(productCategory) };
            return _this.post(_this.productCategoryRoot, { data: data });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.inventory.productCategories);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                navigate('/product_categories');
            }
        });
    };
    ProductCategoryService.getInstance = function () {
        if (!ProductCategoryService.productCategoryService) {
            ProductCategoryService.productCategoryService = new ProductCategoryService();
        }
        return ProductCategoryService.productCategoryService;
    };
    return ProductCategoryService;
}(ApiService));
export default ProductCategoryService;
